'use client';

import { type ReactNode, createContext, useRef, type JSX } from 'react';

import type { ServiceRemindersState } from '../store/ServiceRemindersStore';
import { createServiceRemindersStore } from '../store/ServiceRemindersStore';

export type ServiceRemindersStoreApi = ReturnType<typeof createServiceRemindersStore>;

export type ServiceRemindersStoreProviderProps = {
    children: ReactNode;
    serviceRemindersState?: ServiceRemindersState;
};

// TODO: Refactor this later to use the correct naming convention
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ServiceRemindersStoreContext = createContext<ServiceRemindersStoreApi | undefined>(undefined);

export function ServiceRemindersStoreProvider({ children, serviceRemindersState }: ServiceRemindersStoreProviderProps): JSX.Element {
    const storeRef = useRef<ServiceRemindersStoreApi>(undefined);

    if (!storeRef.current) {
        storeRef.current = createServiceRemindersStore(serviceRemindersState);
    }

    return <ServiceRemindersStoreContext.Provider value={storeRef.current}>{children}</ServiceRemindersStoreContext.Provider>;
}
